import React, { useCallback, useEffect, useState } from "react";
import toastError from "../../errors/toastError";

import {
  Button,
  Dialog,
  DialogActions,
} from "@material-ui/core";

import html2pdf from "html2pdf.js/dist/html2pdf.bundle.min";

export default function TicketMessagesDialog({ open, handleClose, ticketId }) {
  const [exportedToPDF, setExportedToPDF] = useState(false);

  const handleExportToPDF = useCallback(() => {
    const messagesListElement = document.getElementById("messagesList"); // Id do elemento que você deseja exportar para PDF
    const headerElement = document.getElementById("TicketHeader"); // Id do elemento de cabeçalho que você deseja exportar

    const pdfOPtions = {
      margin: 1,
      filename: `relatório_atendimento_${ticketId}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
    };

    if (messagesListElement && headerElement) {
      const headerClone = headerElement.cloneNode(true);
      const messagesListClone = messagesListElement.cloneNode(true);

      const containerElement = document.createElement("div");
      containerElement.appendChild(headerClone); // Adicione o elemento do cabeçalho
      containerElement.appendChild(messagesListClone);
      html2pdf().from(containerElement).set(pdfOPtions).save();
    } else {
      toastError("Elemento não encontrado para exportar.");
    }
  }, [ticketId]);

  useEffect(() => {
    if (open && !exportedToPDF) {
      // Execute a exportação para PDF e feche o Dialog
      handleExportToPDF();
      setExportedToPDF(true);
      handleClose(); // Fecha o Dialog
    }
  }, [open, exportedToPDF, handleExportToPDF, handleClose]);

  useEffect(() => {
    if (!open) {
      setExportedToPDF(false);
    }
  }, [open]);

  return (
    <Dialog maxWidth="md" onClose={handleClose} open={open}>
      <DialogActions>
        <Button onClick={handleExportToPDF} color="primary">
          Exportar para PDF
        </Button>
        <Button onClick={handleClose} color="primary">
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
